import * as React from 'react';
import { DataShape, Field, FormProps, reduxForm } from 'redux-form';

import history from 'login-utils/history';
import * as specialtyVehicleForm from 'login-utils/specialtyVehicleForm';
import LargeIconButtonGroup from 'login-components/Common/LargeIconButtonGroup/LargeIconButtonGroup';
import { LargeIconButtonConfig } from 'login-components/Common/Buttons/LargeIconButton';
import SpecialtyVehicleBoatSVG from 'login-components/Common/svg/SpecialtyVehicleBoatSVG';
import SpecialtyVehicleRVSVG from 'login-components/Common/svg/SpecialtyVehicleRVSVG';
import SpecialtyVehiclePowersportSVG from 'login-components/Common/svg/SpecialtyVehiclePowersportSVG';
import States from 'login-constants/states';

const specialtyVehicleCategoryConfigs: LargeIconButtonConfig[] = [
  {
    value: 'BOAT',
    iconComponent: SpecialtyVehicleBoatSVG,
    buttonId: 'it-chooseSpecialtyVehicleCategoryBoat',
    text: 'Boat/Marine',
    subText: 'Buy a boat or change your loan terms.',
  },
  {
    value: 'RV',
    iconComponent: SpecialtyVehicleRVSVG,
    buttonId: 'it-chooseSpecialtyVehicleCategoryRV',
    text: 'Recreational vehicle (RV)',
    subText: 'Buy a recreational vehicle or refinance your current one.',
  },
  {
    value: 'POWERSPORT',
    iconComponent: SpecialtyVehiclePowersportSVG,
    buttonId: 'it-chooseSpecialtyVehicleCategoryPowersport',
    text: 'Powersport',
    subText: 'Buy or refinance a motorcycle or powersport vehicle.',
  },
];

namespace SpecialtyVehicleCategory {
  export type Props = ReactRouter.RouteComponentProps<{}, {}>;
}

export class SpecialtyVehicleCategory extends React.Component<SpecialtyVehicleCategory.Props> {
  onSelect = () => {
    history.push(States.SPECIALTY_VEHICLE_LOAN_PURPOSE);
  };

  render(): React.ReactNode {
    return (
      <Field
        name={specialtyVehicleForm.FIELDS.specialtyVehicleCategory}
        configs={specialtyVehicleCategoryConfigs}
        onSelect={this.onSelect}
        component={LargeIconButtonGroup}
      />
    );
  }
}

const initialValues: DataShape = {
  specialtyVehicleCategory: null,
  loanPurpose: null,
};

export default reduxForm<
  FormProps<DataShape, SpecialtyVehicleCategory.Props, ReduxState>,
  SpecialtyVehicleCategory.Props,
  ReduxState
>({
  initialValues,
  ...specialtyVehicleForm.FORM_CONFIG,
})(SpecialtyVehicleCategory);
